'use client';

import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { EventService } from '@/shared/lib/event-service';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;

export const CookiesButton = (props: Props) => {
    const t = useTranslations();
    return (
        <Layout
            element="button"
            type="button"
            media={{
                ...props.media,
                initial: {
                    fontSize: '0.75rem',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    ...props.media?.initial,
                },
                xl: {
                    fontSize: '0.875rem',
                },
            }}
            onClick={() => EventService.trigger('cookies:view-detail')}
            {...props}
        >
            {t('FOOTER.BOTTOM.COOKIES')}
        </Layout>
    );
};
